import { type Ref, ref } from 'vue';

export const useEntity = <T>(initialState?: T) => ({
  entity: ref<T | undefined>(initialState) as Ref<T | undefined>,
});
